import * as React from 'react';
import { SVGProps } from 'react';

const IconRemoveSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 6h7v1H2z" />
  </svg>
);
export default IconRemoveSizeXs;
